import {
  Box,
  Button,
  Dialog,
  Heading,
  Icon,
  Loading,
  Text,
} from '@redriverpress/system'
import PropTypes from 'prop-types'

export default function ConfirmActionDialog({
  isOpen,
  title,
  subtitle,
  onClose,
  isPending,
  onConfirm,
  onOpenChange,
  confirmLabel,
  confirmIcon,
  cancelLabel,
  cancelIcon,
}) {
  return (
    <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay />
        <Dialog.StyledContent
          onPointerDownOutside={e => {
            e.preventDefault()
            onOpenChange(false)
          }}
        >
          <Dialog.StyledTitle>
            <Heading as='h6' mb={0}>
              {title}
            </Heading>
          </Dialog.StyledTitle>
          {isPending ? (
            <Box textAlign='center'>
              <Loading height='5rem' />
            </Box>
          ) : (
            <>
              <Text>{subtitle}</Text>
              <Box textAlign='center' mt={4} mb={3}>
                <Button secondary small mr={2} onClick={onClose}>
                  <Icon icon={cancelIcon} pr={2} />
                  {cancelLabel}
                </Button>
                <Button small onClick={onConfirm}>
                  <Icon icon={confirmIcon} pr={2} />
                  {confirmLabel}
                </Button>
              </Box>
            </>
          )}
        </Dialog.StyledContent>
      </Dialog.Portal>
    </Dialog.Root>
  )
}

ConfirmActionDialog.defaultProps = {
  subtitle: 'Are you sure?',
  confirmLabel: 'Yes',
  confirmIcon: 'check',
  cancelLabel: 'cancel',
  cancelIcon: 'times',
}

ConfirmActionDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onClose: PropTypes.func.isRequired,
  isPending: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  confirmLabel: PropTypes.string,
  confirmIcon: PropTypes.string,
  cancelLabel: PropTypes.string,
  cancelIcon: PropTypes.string,
}
